import { render, staticRenderFns } from "./photo-top.vue?vue&type=template&id=266b485d&scoped=true&"
import script from "./photo-top.vue?vue&type=script&lang=js&"
export * from "./photo-top.vue?vue&type=script&lang=js&"
import style0 from "./photo-top.vue?vue&type=style&index=0&id=266b485d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266b485d",
  null
  
)

export default component.exports